import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './assets/style.css'
import { preventDoubleTapZoom } from './utils/mobileOptimization'
import { setGlobalRouter } from './services/http'

// // 性能监控
// const performanceMonitor = {
//   init() {
//     // 监控页面加载性能
//     window.addEventListener('load', () => {
//       const navigation = performance.getEntriesByType('navigation')[0]
//       const paint = performance.getEntriesByType('paint')

//       const performanceData = {
//         domContentLoaded: navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart,
//         loadComplete: navigation.loadEventEnd - navigation.loadEventStart,
//         firstPaint: paint.find(p => p.name === 'first-paint')?.startTime,
//         firstContentfulPaint: paint.find(p => p.name === 'first-contentful-paint')?.startTime
//       }
//       console.log('页面加载性能:', performanceData)
//     })

//     // 监控路由切换性能
//     router.beforeEach((to, from, next) => {
//       const startTime = performance.now()
//       router.afterEach(() => {
//         const endTime = performance.now()
//         console.log(`路由切换耗时: ${endTime - startTime}ms`, { from: from.path, to: to.path })
//       })
//       next()
//     })
//   }
// }

const app = createApp(App)

// 初始化移动端优化
preventDoubleTapZoom()

// 设置全局路由实例，用于HTTP拦截器中的路由跳转
setGlobalRouter(router)

app.use(router)
app.use(i18n)

// 初始化性能监控
// performanceMonitor.init()

app.mount('#app')
